/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

const objectToCSV = (data, columnsSize) => {
	let csv = "";
	if (data && data.length > 0) {
		const separator = ",";
		const newline = "\r\n";
		const dataKeys = Object.keys(data[0]);
		// Take only the first 'columnsSize' fields
		const keys = dataKeys.slice(0, columnsSize);
		const header = keys.join(separator);

		csv =
			header +
			newline +
			data
				.map((row) => {
					return keys
						.map((k) => {
							let cell = row[k];
							switch (k) {
								case "prompt":
									if (/,/.test(cell)) {
										cell = `"${cell}"`;
									}
									break;
								default:
							}
							return cell;
						})
						.join(separator);
				})
				.join(newline);
	}

	return csv;
};

export default objectToCSV;
